import "./myInfo.scss";
import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Box,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Stack,
  Typography,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
import { useFormik } from "formik";
import { DoctorMyInfoSchema } from "../../../helpers/validation";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import provincias from "../../../constants/provincias";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CloudUploadIcon from "@mui/icons-material/CloudUpload"; // Importa el icono de carga
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { TermsAndConditionsModal } from "../../../components/doctor/TermsAndConditionsModal";
import { Estados } from "../../../constants/estados";
import { enqueueSnackbar } from "notistack";
import { makeStyles } from "@material-ui/core/styles";
import { theme } from "../../../theme";
import { logoutDoctor } from "../../../utils";
import { getDecryptedDataFromSessionStorage, saveEncryptedDataToSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const maxSizeFile = 2000000;

const MyInfo = (props) => {
  const classes = useStyles(theme);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [approve, setApprove] = useState(null);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [loadingFirm, setLoadingFirm] = useState(false);
  const [doctorFirm, setDoctorFirm] = useState("");

  const fileInputRef = useRef(null);
  const handleCloseModalTermsAndConditions = () => setOpenModal(false);
  const handleOpenModalTermsAndConditions = () => setOpenModal(true);

  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const { idMedico, email, accessToken } = data;

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleChangeUploadDocumentation = async (event) => {
    const fileName = event.target.files[0].name;
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const fileSize = event.target.files[0].size;

    

    if (fileSize > 2000000) {
      enqueueSnackbar(
        `El archivo seleccionado excede el tamaño máximo permitido de 2 MB. Por favor, seleccione un archivo más pequeño.`,
        { variant: "error" }
      );
      fileInputRef.current.value = "";
      return;
    }

    try {
      //const idMedico = localStorage.getItem("idMedico");
      const formData = new FormData();
      const allowedExtensions = ["jpg", "jpeg", "png"];

      if (allowedExtensions.includes(fileExtension)) {
        formData.append("Imagen", event.target.files[0]);
      } else {
        enqueueSnackbar(
          `El archivo ${fileName} tiene un formato no permitido. Seleccione otro archivo.`,
          { variant: "error" }
        );
        return;
      }

      formData.append("IdMedico", idMedico);

      const response = await axios.post(
        `${API_BASE_URL}Medicos/AgregaDocumentacion`,
        formData,
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "Ok") {
        fetchData();
        enqueueSnackbar("Documento agregado con éxito", { variant: "success" });
      } else {
        enqueueSnackbar(response.data.errors[0], { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    }
  };

  const handleUploadFirm = async (event) => {
    setLoadingFirm(true);
    const fileName = event.target.files[0].name;
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const fileSize = event.target.files[0].size;

    if (fileSize > 2000000) {
      setLoadingFirm(false);
      enqueueSnackbar(
        `El archivo seleccionado excede el tamaño máximo permitido de 2 MB. Por favor, seleccione un archivo más pequeño.`,
        { variant: "error" }
      );
      return;
    }

    try {
      //const idMedico = localStorage.getItem("idMedico");
      const formData = new FormData();
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];

      if (allowedExtensions.includes(fileExtension)) {
        formData.append("Imagen", event.target.files[0]);
      } else {
        setLoadingFirm(false);
        enqueueSnackbar(
          `El archivo tiene un formato no permitido. Seleccione otro archivo.`,
          { variant: "error" }
        );
        return;
      }

      formData.append("IdMedico", idMedico);

      const response = await axios.post(
        `${API_BASE_URL}Medicos/AgregaFirma`,
        formData,
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setDoctorFirm(response.data.result.s3link);
        setLoadingFirm(false);
        enqueueSnackbar("Documento agregado con éxito", { variant: "success" });
      } else {
        enqueueSnackbar(response.data.errors[0], { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    }
  };

  const handleClickDocumentation = (s3Link) => {
    const url = /^https?:\/\//i.test(s3Link) ? s3Link : `https://${s3Link}`;
    window.open(url, "_blank");
  };

  const actualizaMedico = async (formData) => {
    try {
      //const idMedico = localStorage.getItem("idMedico");
      //const email = localStorage.getItem("email");

      formData.fechaNacimiento = new Date(
        formData.fechaNacimiento
      ).toISOString();

      const response = await axios.put(
        `${API_BASE_URL}Medicos/ActualizaMedico`,
        {
          ...formData,
          idMedico: idMedico,
          email: email,
        },
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data; // Puedes devolver la respuesta si es necesario
    } catch (error) {
      console.error("Error al actualizar médico:", error);
      throw error; // Puedes lanzar el error para que sea manejado por el componente que llama a esta función
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      lastname: "",
      specialty: "",
      birthdate: "",
      sex: "",
      phone: "",
      address: "",
    },
    validationSchema: DoctorMyInfoSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        //const idMedico = localStorage.getItem("idMedico");
        //const email = localStorage.getItem("email");

        const formData = {
          idMedico: idMedico,
          nombre: values.name,
          apellido: values.lastname,
          especialidad: values.specialty,
          telefono: values.phone,
          email: email,
          direccionConsultorio: values.address,
          fechaNacimiento: values.birthdate,
          sexo: values.sex,
          pais: "",
        };

        await actualizaMedico(formData);
        sessionStorage.clear()
        saveEncryptedDataToSessionStorage(
          {
            ...data,
            nombre: values.name,
            apellido: values.lastname,
            especialidad: values.specialty
          },
          SECRET_KEY
        );
        // localStorage.setItem("nombre", values.name);
        // localStorage.setItem("apellido", values.lastname);
        // localStorage.setItem("especialidad", values.specialty);

        setMessage({
          type: "success",
          text: "¡Información actualizada con éxito!",
        });
      } catch (error) {
        setMessage({
          type: "error",
          text: "Hubo un error al actualizar la información.",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      //const idMedico = localStorage.getItem("idMedico");

      const response = await axios.get(
        `${API_BASE_URL}Medicos/ConsultaMedico/${idMedico}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data?.status === "Ok") {
        const data = response.data.result;
        setUserData(data);
        setDoctorFirm(data.imgLink ?? "");
        setApprove(response.data.result.aprobado?.toLowerCase() === "true");

        const formattedBirthdate = data?.fechaNacimiento
          ? new Date(data?.fechaNacimiento).toISOString().split("T")[0]
          : "1900-01-01";

        formik.setValues({
          name: data?.nombre || "",
          lastname: data?.apellido || "",
          dni: data?.dni || "",
          registrationType: data?.tipoMatricula || "",
          registrationNumber: data?.numeroMatricula || "",
          province: data?.provinciaMatricula || "",
          specialty: data?.especialidad || "",
          birthdate: formattedBirthdate,
          sex: data?.sexo || "",
          phone: data?.telefono || "",
          address: data?.direccionConsultorio || "",
        });
      } else if (response.data?.status === "Error") {
        logoutDoctor();
        window.location.href = "/"; 
      }
    } catch (error) {
      console.error("Error al cargar la información del médico", error);
    } finally {
      setPageLoaded(true);
    }
  };

  useEffect(() => {
    if (message) {
      setIsSnackbarOpen(true);
      const timerId = setTimeout(() => {
        setIsSnackbarOpen(false);
      }, 5000);
      return () => clearTimeout(timerId); // Limpiar el temporizador al desmontar el componente
    } else {
      setIsSnackbarOpen(false); // Asegurarse de que el Snackbar se cierre cuando no hay mensaje
    }
  }, [message]);

  useEffect(() => {
    fetchData();
  }, []);

  if (!pageLoaded) {
    return (
      <PageLayoutDoctor>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        </Container>
      </PageLayoutDoctor>
    );
  }

  return (
    <PageLayoutDoctor>
      <TermsAndConditionsModal
        openModal={openModal}
        onClose={handleCloseModalTermsAndConditions}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <form onSubmit={formik.handleSubmit}>
            <Card
              sx={{
                border: "0.5px solid #dddddd",
                padding: "1px",
                boxShadow: "1px 1px #dddddd",
              }}
            >
              <CardHeader
                subheader="En esta sección podrá ver y actualizar su información"
                title="Información del usuario"
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(formik.touched.name && formik.errors.name)}
                      fullWidth
                      helperText={formik.touched.name && formik.errors.name}
                      label="Nombre"
                      name="name"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.lastname && formik.errors.lastname
                      )}
                      fullWidth
                      helperText={
                        formik.touched.lastname && formik.errors.lastname
                      }
                      label="Apellido"
                      name="lastname"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.lastname}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(formik.touched.dni && formik.errors.dni)}
                      fullWidth
                      helperText={formik.touched.dni && formik.errors.dni}
                      label="Número de DNI"
                      name="dni"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.dni}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <InputLabel
                        htmlFor="registrationType"
                        sx={{ color: "text.primary" }}
                      >
                        Tipo de Matrícula
                      </InputLabel>
                      <Select
                        native
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.registrationType}
                        label="Tipo de Matrícula"
                        inputProps={{
                          name: "registrationType",
                          id: "registrationType",
                        }}
                        sx={{ color: "text.primary" }}
                        error={Boolean(
                          formik.touched.registrationType &&
                            formik.errors.registrationType
                        )}
                        disabled
                      >
                        <option value=""></option>
                        <option value="MN">Matrícula Nacional</option>
                        <option value="MP">Matrícula Provincial</option>
                      </Select>
                      {formik.touched.registrationType &&
                        formik.errors.registrationType && (
                          <Typography
                            color="error"
                            variant="body2"
                            sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                          >
                            {formik.errors.registrationType}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.registrationNumber &&
                          formik.errors.registrationNumber
                      )}
                      fullWidth
                      helperText={
                        formik.touched.registrationNumber &&
                        formik.errors.registrationNumber
                      }
                      label="Número de matrícula"
                      name="registrationNumber"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.registrationNumber}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <InputLabel
                        htmlFor="provincia"
                        sx={{ color: "text.primary" }}
                      >
                        Provincia
                      </InputLabel>
                      <Select
                        native
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.province}
                        label="Provincia"
                        inputProps={{
                          name: "province",
                          id: "provincia",
                        }}
                        sx={{ color: "text.primary" }}
                        error={Boolean(
                          formik.touched.province && formik.errors.province
                        )}
                        disabled
                      >
                        <option value=""></option>
                        {provincias &&
                          provincias.map((prov) => (
                            <option key={prov.sisa} value={prov.recipe}>
                              {prov.sisa}
                            </option>
                          ))}
                      </Select>
                      {formik.touched.province && formik.errors.province && (
                        <Typography
                          color="error"
                          variant="body2"
                          sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                        >
                          {formik.errors.province}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.specialty && formik.errors.specialty
                      )}
                      fullWidth
                      helperText={
                        formik.touched.specialty && formik.errors.specialty
                      }
                      label="Especialidad"
                      name="specialty"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.specialty}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      type="date"
                      error={Boolean(
                        formik.touched.birthdate && formik.errors.birthdate
                      )}
                      fullWidth
                      helperText={
                        formik.touched.birthdate && formik.errors.birthdate
                      }
                      label="Fecha de nacimiento"
                      name="birthdate"
                      onBlur={formik.handleBlur}
                      onChange={(e) =>
                        formik.setFieldValue("birthdate", e.target.value)
                      }
                      value={formik.values.birthdate}
                      variant="outlined"
                      disabled
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <InputLabel htmlFor="sex" sx={{ color: "text.primary" }}>
                        Sexo
                      </InputLabel>
                      <Select
                        native
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.sex}
                        label="Sexo"
                        inputProps={{
                          name: "sex",
                          id: "sex",
                        }}
                        sx={{ color: "text.primary" }}
                        error={Boolean(formik.touched.sex && formik.errors.sex)}
                        disabled
                      >
                        <option value=""></option>
                        <option value="F">Femenino</option>
                        <option value="M">Masculino</option>
                        <option value="X">Otro</option>
                      </Select>
                      {formik.touched.sex && formik.errors.sex && (
                        <Typography
                          color="error"
                          variant="body2"
                          sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                        >
                          {formik.errors.sex}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={userData?.email ?? ""}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.phone && formik.errors.phone
                      )}
                      fullWidth
                      helperText={formik.touched.phone && formik.errors.phone}
                      label="Teléfono"
                      name="phone"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.phone}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "black", // Color del borde
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.address && formik.errors.address
                      )}
                      fullWidth
                      helperText={
                        formik.touched.address && formik.errors.address
                      }
                      label="Dirección del consultorio"
                      name="address"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.address}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "black", // Color del borde
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <Stack sx={{ width: "100%" }} spacing={2}>
                      <Alert
                        fullWidth
                        severity={userData.estado === 1 ? "success" : "error"}
                      >
                        {String(Estados[userData.estado]).toUpperCase()}
                      </Alert>
                    </Stack>
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <Button
                      onClick={handleOpenModalTermsAndConditions}
                      variant="contained"
                    >
                      Términos y condiciones
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Distribuye los elementos al final y al principio
                  alignItems: "center", // Alinea al centro verticalmente
                  p: 2,
                }}
              >
                <Stack
                  sx={{ width: "auto" }} // Ancho del 60% para el mensaje
                  spacing={2}
                >
                  {isSnackbarOpen && (
                    <Alert fullWidth severity={message.type}>
                      {message.text}
                    </Alert>
                  )}
                </Stack>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  sx={{ ml: 2 }} // Margen a la izquierda del botón
                >
                  Actualizar
                </LoadingButton>
              </Box>
            </Card>
          </form>
        </Container>
      </Box>
      <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
        <Container maxWidth={false}>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #dddddd",
            }}
          >
            <CardHeader
              subheader="La firma se utilizará en la receta generada por el médico"
              title="Firma del médico"
            />
            <Divider />
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {!doctorFirm && !loadingFirm && (
                <div style={{ margin: "10px 0px" }}>
                  <input
                    accept="image/*"
                    className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={handleUploadFirm}
                  />
                  <label
                    htmlFor="contained-button-file"
                    className={classes.containerBtn}
                  >
                    <div className={classes.btnFab}>
                      <AddPhotoAlternateIcon color="primary" />
                    </div>
                  </label>
                </div>
              )}

              {doctorFirm && !loadingFirm && (
                <div className={classes.containerImage}>
                  <img alt="logo-receta" src={doctorFirm} width="180" />
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="edit-button-file"
                      multiple
                      type="file"
                      onChange={handleUploadFirm}
                    />
                    <label
                      htmlFor="edit-button-file"
                      className={classes.containerBtn}
                    >
                      <Tooltip title="Modificar firma">
                        <div className={classes.btnFab}>
                          <EditOutlinedIcon color="primary" />
                        </div>
                      </Tooltip>
                    </label>
                  </div>
                </div>
              )}

              {loadingFirm && (
                <div className={classes.containerImage}>
                  <CircularProgress />
                </div>
              )}
            </CardContent>
            <Divider />
          </Card>
        </Container>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
        <Container maxWidth={false}>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #dddddd",
            }}
          >
            <CardHeader
              subheader="Documentación presentada por el usuario"
              title="Documentación"
              action={
                userData.documentacion &&
                userData.documentacion.length < 3 && (
                  <Button
                    component="label"
                    variant="contained"
                    onChange={handleChangeUploadDocumentation}
                    multiple
                    startIcon={<CloudUploadIcon />}
                    sx={{ mt: 2, visibility: approve ? "hidden" : "visible" }}
                  >
                    Subir documentos
                    <VisuallyHiddenInput type="file" ref={fileInputRef} />
                  </Button>
                )
              }
            />
            <Divider />
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              {userData &&
              userData.documentacion &&
              userData.documentacion.length > 0 ? (
                userData.documentacion.map((doc, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <LoadingButton
                      variant="outlined"
                      color="primary"
                      loading={false}
                      onClick={() => handleClickDocumentation(doc.s3Link)}
                      sx={{
                        borderRadius: "8px",
                        minWidth: 0,
                        padding: 0,
                        width: "36px",
                        height: "36px",
                        marginRight: "8px",
                      }}
                      loadingPosition="start"
                    >
                      <CloudDownloadOutlinedIcon />
                    </LoadingButton>
                    <Stack sx={{ width: "100%", ml: "8px" }} spacing={2}>
                      <Alert fullWidth color="warning" icon={false}>
                        {doc.fileName}
                      </Alert>
                    </Stack>
                  </Box>
                ))
              ) : (
                <p>No hay documentos disponibles.</p>
              )}
            </CardContent>
            <Divider />
          </Card>
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default MyInfo;

const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
  button: {
    color: theme.palette.primary.main,
    margin: "13px",
  },
  buttonEdit: {
    margin: "13px",
    backgroundColor: "#fff",
  },
  containerBtn: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    alignItems: "center",
  },
  textBtn: {
    fontFamily: "'Poppins',sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    color: theme.palette.primary.main,
  },
  containerImage: {
    padding: "10px",
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    justifyContent: "center",
  },
  btnFab: {
    display: "flex",
    cursor: "pointer",
    padding: "10px",
    borderRadius: 50,
    width: 50,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(241, 241,241,0.8)",
    "&:hover": {
      opacity: 0.9,
    },
  },
  containerTextAndBtn: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    width: "100%",
  },
}));
